import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import './styles.css'
import { PortalPage } from './portal/PortalPage'
import { AdminLayout } from './admin/AdminLayout'
import { UsersPage } from './admin/UsersPage'
import { UserDetailPage } from './admin/UserDetailPage'
import { ReviewPage } from './admin/ReviewPage'
import { AuditPage } from './admin/AuditPage'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Benutzer: eine einzige Seite ohne Navigation. Sie kommen aus einer
            Mail, haben genau eine Aufgabe und sollen nichts suchen muessen. */}
        <Route path="/" element={<PortalPage />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/pruefen" replace />} />
          <Route path="pruefen" element={<ReviewPage />} />
          <Route path="benutzer" element={<UsersPage />} />
          <Route path="benutzer/:user_id" element={<UserDetailPage />} />
          <Route path="protokoll" element={<AuditPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
